import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L7 5.58579L11.2929 1.29289C11.6834 0.902369 12.3166 0.902369 12.7071 1.29289C13.0976 1.68342 13.0976 2.31658 12.7071 2.70711L8.41421 7L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L7 8.41421L2.70711 12.7071C2.31658 13.0976 1.68342 13.0976 1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L5.58579 7L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}